import api from './api';
import { 
  CreateProjectInviteDto, 
  ProjectInviteDto, 
  AcceptProjectInviteDto, 
  DeclineProjectInviteDto 
} from '../interfaces/projectInvite';

const projectInviteService = {
  // Create a new project invite
  async createInvite(projectId: string, data: CreateProjectInviteDto): Promise<ProjectInviteDto> {
    const response = await api.post(`/projects/${projectId}/invites`, data);
    
    // Verificar se a resposta está em response.data.data ou response.data
    if (response.data && response.data.data) {
      return response.data.data;
    }
    return response.data;
  },

  // Get all invites for a project
  async getProjectInvites(projectId: string): Promise<ProjectInviteDto[]> {
    try {
      const response = await api.get(`/projects/${projectId}/invites`);
      
      // Verificar se a resposta está em response.data.data (padrão ApiResponse)
      if (response.data && response.data.data) {
        return Array.isArray(response.data.data) ? response.data.data : [];
      }
      
      // Se não, verificar se está diretamente em response.data
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error('Error fetching project invites:', error);
      return [];
    }
  },

  // Get invite details by code
  async getInviteByCode(inviteCode: string): Promise<ProjectInviteDto> {
    const response = await api.get(`/project-invites/by-code/${inviteCode}`);
    return response.data;
  },

  // Accept a project invite
  async acceptInvite(inviteCode: string): Promise<void> {
    const data: AcceptProjectInviteDto = { inviteCode };
    await api.post('/project-invites/accept', data);
  },

  // Decline a project invite
  async declineInvite(inviteCode: string): Promise<void> {
    const data: DeclineProjectInviteDto = { inviteCode };
    await api.post('/project-invites/decline', data);
  },

  // Delete a project invite
  async deleteInvite(projectId: string, inviteId: string): Promise<void> {
    await api.delete(`/projects/${projectId}/invites/${inviteId}`);
  }
};

export default projectInviteService;
